import React, { useEffect, useState, useContext } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { logEvent } from 'firebase/analytics';
import { LocalizationProvider, LocalizationContext } from './localization/LocalizationContext';
import LanguageLoader from './components/LanguageLoader';
import './i18n';

import './css/index.css';
import './css/form-redesign-patch.css';
import './css/font-size-increase.css';
import { analytics } from './firebase';

import Main from './pages/main';
import TestModeIndicator from './components/TestModeIndicator';
import Userpage from './pages/userpage';
import Add from './pages/add';
import Buy from './pages/buy';
import Kinotel from './pages/kinotel';
import ORANGE from './pages/orange';
import CRMA from './pages/crm';
import Menucrm from './pages/menucrm';
import EditAdd from './pages/editadd';
import Global from './pages/global';
import ProtectedRoute from './pages/ProtecterRoute';
import RequireOnboarding from './components/RequireOnboarding';
import LoyaltyCrm from './pages/LoyaltyCrmInterface/LoyaltyCrm';
import DeliveryCrmInterface from './pages/DeliveryInterface/DeliveryCrmInterface';
import AddCardCrm from './pages/addCardCrm';
import StartModal from './pages/startModal';
import GetCoins from "./pages/GetCoins";
import EmployeeLoyalty from './pages/EmployeeLoyalty';
import LoyaltyQrPage from './pages/LoyaltyQrPage';
import PaymentReturn from './pages/PaymentReturn';
import UserOnboarding from './pages/UserOnboarding';
import SyrveTestPage from './pages/SyrveTestPage';
import CategoryCms from './pages/CategoryCms';

const AppContent = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(true);
  const { isLoading } = useContext(LocalizationContext);

  const handleXBarItemChange = (item) => {
    console.log('Bar item changed:', item);
  };

  useEffect(() => {
    if (!localStorage.getItem('activeItem')) {
      localStorage.setItem('activeItem', '2');
    }

    logEvent(analytics, 'page_view');
  }, []);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        localStorage.setItem('LOGstatus', 'true');
        localStorage.setItem('USER_NAME', user.displayName || '');
        localStorage.setItem('USER_LOGIN', user.email || '');
        setIsAuthenticated(true);
      } else {
        localStorage.setItem('LOGstatus', 'false');
        setIsAuthenticated(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {isLoading && <LanguageLoader />}
      <Router>
        <Routes>
          <Route path="/onboarding" element={<UserOnboarding />} />
          <Route path="/userpage" element={<Userpage handleXBarItemChange={handleXBarItemChange} />} />
          <Route path="/" element={<RequireOnboarding><Main handleXBarItemChange={handleXBarItemChange} /></RequireOnboarding>} />
          <Route path="/home" element={<RequireOnboarding><Main handleXBarItemChange={handleXBarItemChange} /></RequireOnboarding>} />
          <Route path="/delivery" element={<RequireOnboarding><Main handleXBarItemChange={handleXBarItemChange} /></RequireOnboarding>} />
          <Route path="/dinein" element={<RequireOnboarding><Main handleXBarItemChange={handleXBarItemChange} /></RequireOnboarding>} />
          <Route path="/locations" element={<RequireOnboarding><Main handleXBarItemChange={handleXBarItemChange} /></RequireOnboarding>} />
          <Route path="/menu" element={<RequireOnboarding><Main handleXBarItemChange={handleXBarItemChange} /></RequireOnboarding>} />
          <Route path="/profile" element={<RequireOnboarding><Main handleXBarItemChange={handleXBarItemChange} /></RequireOnboarding>} />
          <Route path="/loyalty" element={<RequireOnboarding><Main handleXBarItemChange={handleXBarItemChange} /></RequireOnboarding>} />
          <Route path="/d/home" element={<Navigate to="/home" replace />} />
          <Route path="/d/delivery" element={<Navigate to="/delivery" replace />} />
          <Route path="/d/dinein" element={<Navigate to="/dinein" replace />} />
          <Route path="/d/locations" element={<Navigate to="/locations" replace />} />
          <Route path="/d/menu" element={<Navigate to="/menu" replace />} />
          <Route path="/d/profile" element={<Navigate to="/profile" replace />} />
          <Route path="/d/loyalty" element={<Navigate to="/loyalty" replace />} />
          <Route
            path="/edit-add/:companyId/:productId"
            element={<RequireOnboarding><EditAdd handleXBarItemChange={handleXBarItemChange} /></RequireOnboarding>}
          />
          <Route path="/:company" element={<RequireOnboarding><Main handleXBarItemChange={handleXBarItemChange} /></RequireOnboarding>} />
          <Route
            path="/fastDeliveryCRM"
            element={<ProtectedRoute element={<Menucrm handleXBarItemChange={handleXBarItemChange} />} />}
          />
          <Route path="/g" element={<RequireOnboarding><Global handleXBarItemChange={handleXBarItemChange} /></RequireOnboarding>} />
          <Route
            path="/loyalty-crm"
            element={<ProtectedRoute element={<LoyaltyCrm handleXBarItemChange={handleXBarItemChange} />} />}
          />
          <Route path='/get-coins' element={<RequireOnboarding><GetCoins handleXBarItemChange={handleXBarItemChange} /></RequireOnboarding>} />
          <Route path='/my-qr' element={<RequireOnboarding><LoyaltyQrPage handleXBarItemChange={handleXBarItemChange} /></RequireOnboarding>} />
          <Route path='/payment-return' element={<RequireOnboarding><PaymentReturn /></RequireOnboarding>} />
          <Route
            path="/delivery-crm"
            element={<ProtectedRoute element={<DeliveryCrmInterface handleXBarItemChange={handleXBarItemChange} />} />}
          />
          <Route
            path="/add-loyalty-card"
            element={<ProtectedRoute element={<AddCardCrm handleXBarItemChange={handleXBarItemChange} />} />}
          />
          <Route
            path="/employee-loyalty"
            element={<ProtectedRoute element={<EmployeeLoyalty handleXBarItemChange={handleXBarItemChange} />} />}
          />
          <Route path="/kinotel" element={<RequireOnboarding><Kinotel handleXBarItemChange={handleXBarItemChange} /></RequireOnboarding>} />
          <Route path="/orange" element={<RequireOnboarding><ORANGE handleXBarItemChange={handleXBarItemChange} /></RequireOnboarding>} />
          <Route path="/crm" element={<CRMA handleXBarItemChange={handleXBarItemChange} />} />
          <Route path="/addd" element={<Add handleXBarItemChange={handleXBarItemChange} />} />
          <Route path="/buy" element={<RequireOnboarding><Buy handleXBarItemChange={handleXBarItemChange} /></RequireOnboarding>} />
          <Route
            path="/syrve-test"
            element={<ProtectedRoute element={<SyrveTestPage />} />}
          />
          <Route
            path="/category-cms"
            element={<ProtectedRoute element={<CategoryCms />} />}
          />
        </Routes>
      </Router>
    </>
  );
};

const App = () => {
  return (
    <LocalizationProvider>
      {/* <TestModeIndicator /> */}
      <AppContent />
    </LocalizationProvider>
  );
};

createRoot(document.getElementById('root')).render(<App />);
